// extracted by mini-css-extract-plugin
export default {"divLoading":"divLoading__u+D72"};